import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
  GET_FAAS
} from "../constants/Faas";

import {
  setFaas,
} from "../actions/Faas";

import ApiService from "../../Services/ApiService";


export function* faas() {
  yield takeEvery(GET_FAAS, function* (action) {
    try {
      let body = {
        service: "faas",
        method: 'GET',
        data: null,
        dataType: "na",
        url: "/ls/org_id"
      };
      let response = yield ApiService.post("/groot/faas", {}, body)
      yield put(setFaas(response.data));
    } catch (e) {
      console.log("FAAAS ERROR");
      yield put(setFaas([]))
    }

  });
}

export default function* rootSaga() {
  yield all([faas()]);
}
